// @/mixins/billingFeaturesMixins.js

export default {
    computed: {
        ordersLimitTranslationPrefix() {
            return this.$store.getters.isTrialTenant
                ? 'billing.trialOrderLimit'
                : 'billing.orderLimit'
        },

        billingEntitlementsReady() {
            return this.$store.getters.billingEntitlementsReady
        },

        canUseScheduler() {
            return this.billingCanUse('scheduler')
        },
        canUseWarehouse() {
            return this.billingCanUse('warehouse')
        },
        canUseWorkTemplates() {
            return this.billingCanUse('work_templates')
        },
        canUseConsumables() {
            return this.billingCanUse('consumables')
        },
        canUsePriceRequestForm() {
            return this.billingCanUse('price_request_form')
        },
        canUseVisitSmsReminder() {
            return this.billingCanUse('visit_sms_reminder')
        },
        canUseEmailAttachments() {
            return this.billingCanUse('email_attachments')
        },
        canUseIncomingMail() {
            return this.billingCanUse('incoming_mail')
        },
        canUsePurchaseInvoices() {
            return this.billingCanUse('purchase_invoices')
        },
        canUseReturns() {
            return this.billingCanUse('returns')
        },
        canUseNextServiceSmsReminder() {
            return this.billingCanUse('next_service_sms_reminder')
        },
        canUseDetailedChangeHistory() {
            return this.billingCanUse('detailed_change_history')
        },
        canUseSupplierAccess() {
            return this.billingCanUse('supplier_access')
        },
        canUseBookingFromOffer() {
            return this.billingCanUse('booking_from_offer')
        },
        canUseTechnicianEarnings() {
            return this.billingCanUse('technician_earnings')
        },
        canUseAdvancedMarkup() {
            return this.billingCanUse('advanced_markup')
        },
        canUsePeriodLock() {
            return this.billingCanUse('period_lock')
        },

        ordersLimit() {
            const value = this.$store.getters.ordersLimit

            if (value === null || value === undefined || value === '') {
                return null
            }

            const limit = Number(value)
            return Number.isFinite(limit) ? limit : null
        },

        ordersRemainingThisMonth() {
            const value = this.$store.getters.ordersRemainingThisMonth

            if (value === null || value === undefined || value === '') {
                return null
            }

            const remaining = Number(value)
            return Number.isFinite(remaining) ? Math.max(0, remaining) : null
        },

        ordersLimitReached() {
            return (
                this.billingEntitlementsReady &&
                this.ordersLimit !== null &&
                this.ordersRemainingThisMonth !== null &&
                this.ordersRemainingThisMonth <= 0
            )
        },

        showOrdersLimitWarning() {
            return (
                this.billingEntitlementsReady &&
                !this.$store.getters.isCurrentLocationBillingLocked &&
                this.ordersLimit !== null &&
                this.ordersRemainingThisMonth !== null &&
                this.ordersRemainingThisMonth <= 10
            )
        },

        orderCreationRestrictionTooltip() {
            if (this.billingDataEditingLocked && this.billingDataEditingRestrictionTooltip) {
                return this.billingDataEditingRestrictionTooltip
            }

            if (!this.ordersLimitReached) return ''

            // return this.$store.getters.isOwnerOrHigher
            //     ? this.$t('billing.orderLimit.reachedOwnerTooltip')
            //     : this.$t('billing.orderLimit.reachedStaffTooltip')

            return this.$store.getters.isOwnerOrHigher
                ? this.$t(`${this.ordersLimitTranslationPrefix}.reachedOwnerTooltip`)
                : this.$t(`${this.ordersLimitTranslationPrefix}.reachedStaffTooltip`)
        },
    },

    methods: {
        billingCanUse(feature) {
            return this.billingEntitlementsReady && this.$store.getters.canUse(feature)
        },

        billingRequiredPlanKey(feature) {
            return this.$store.getters.requiredPlanFor(feature)?.minimum_plan_key || ''
        },

        openBillingFeaturePlans(feature) {
            if (!this.$store.getters.isOwnerOrHigher) return

            const locationId = Number(this.$store.getters.locationId || 0)
            const query = {
                select_plan: '1',
                required_feature: feature,
            }

            if (locationId > 0) {
                query.location_id = String(locationId)
            }

            const route = this.$router.resolve({
                name: 'Subscriptions',
                query,
            })

            window.open(route.href, '_blank', 'noopener')
        },

        orderCreationIsRestricted() {
            const billingLocked = typeof this.billingActionIsRestricted === 'function'
                ? this.billingActionIsRestricted()
                : false

            return billingLocked || this.ordersLimitReached
        },

        orderCreationTooltipOptions(defaultTooltip = '') {
            const restricted = this.orderCreationIsRestricted()

            return {
                value: restricted
                    ? this.orderCreationRestrictionTooltip
                    : defaultTooltip,
                disabled: !restricted && !defaultTooltip,
            }
        },

        openBillingOrdersPlans() {
            if (!this.$store.getters.isOwnerOrHigher) return

            const locationId = Number(this.$store.getters.locationId || 0)
            const query = {
                select_plan: '1',
                required_feature: 'orders_per_month',
            }

            if (this.$store.getters.isTrialTenant) {
                delete query.required_feature
            }

            if (locationId > 0) {
                query.location_id = String(locationId)
            }

            const route = this.$router.resolve({
                name: 'Subscriptions',
                query,
            })

            window.open(route.href, '_blank', 'noopener')
        },
    },
}